import React from 'react';
import { createFilterOptions, FilterOptionsState } from '@material-ui/lab/useAutocomplete';

const defaultFilter = createFilterOptions<any>();

/**
 * MUI v4's useAutocomplete passes inputValue='' to the filter when the input
 * exactly matches the selected value's label. This causes the full unfiltered
 * list to show. We override by always using the real inputValue.
 */
export const getFilterOptionsFix = (inputValue: string) =>
  (options: any[], state: FilterOptionsState<any>) =>
    defaultFilter(options, { ...state, inputValue: inputValue || state.inputValue });

/**
 * When pasting text identical to the current inputValue, onInputChange doesn't
 * fire (value unchanged), so the dropdown never re-evaluates. This forces a
 * reset-and-restore cycle to trigger filtering.
 */
export const getAutocompletePasteInputProps = (
  paramsInputProps: React.InputHTMLAttributes<HTMLInputElement>,
  inputValue: string,
  setInputValue: (value: string) => void
) => ({
  ...paramsInputProps,
  onPaste: (e: React.ClipboardEvent<HTMLInputElement>) => {
    const pasted = e.clipboardData.getData('text');
    if (pasted === inputValue) {
      setInputValue('');
      setTimeout(() => setInputValue(pasted), 0);
    }
  },
});
